
<script>
import { mapActions } from 'vuex';
export default {
    name: 'article-detail',
    created() {

        const {params, query} = this.$route;
        this.routerQuery = this.$route;
        this.textDetail({id: +params.id}, query.event);

    },
    data() {
        return {
            article: {
            },
            routerQuery: {}
        };
    },
    methods: {
        async textDetail(params, evnet) {
            this.$loading(true);
            try {
                const {data} = await this[evnet](params);
                this.article = data;
            } catch (e) {
                throw e;
            } finally {
                this.$loading(false);
            }
        },
        handleClick() {
            this.$router.go(-1);
        },
        ...mapActions('zft', ['getReleaseBid', 'getPolicyDetail', 'getPurTextDetail'])
    },
    filters: {
        filterTime(time){
            return time ? time.split(' ')[0] : '';
        }
    }
};
</script>
<template>
<article class="article-detail">
    <div class="detail-card">
        <h3>基本信息</h3>
        <div class="row"><span>标题</span> {{article.title}}</div>
        <div class="row"><span>业主单位</span> {{article.ownerUnit}}</div>
        <div class="row"><span>招标所在地</span> {{article.province + ' ' + article.city}}</div>
        <div class="row"><span>开标地点</span> {{article.openBidAddress}}</div>
        <div class="row"><span>标的物金额</span> {{article.bidMoney}}</div>
        <div class="row"><span>项目类型</span> {{article.oneTradeName + ' ' +article.twoTradeName}}</div>

    </div>
    <div class="detail-card">
        <h3>报名/投标时间</h3>
        <div class="row"><span>报名开始时间</span> {{article.registerDate}}</div>
        <div class="row"><span>报名截止时间</span> {{article.registerDealDate}}</div>
        <div class="row"><span>投标截止时间</span> {{article.bidDealDate}}</div>
        <div class="row"><span>公式公布时间</span> {{article.formulaResultDate}}</div>
    </div>
    <div class="detail-card">
        <h3>招标联系人</h3>
        <div class="row"><span>联系人姓名</span> {{article.contactName}}</div>
        <div class="row"><span>联系人电话</span> {{article.contactMobile}}</div>
    </div>
    <div class="detail-card">
        <h3>文档信息</h3>
        <div class="row"><span>招标文档</span> <a :href="article.bidDocument" target="_blank">招标文档</a></div>
        <div class="row">
            <span>附件文档</span>
             <a :href="item" v-for="(item, index) in article.annexDocuments" target="_blank" :key="index">附件文档{{index+1}}</a>
        </div>
    </div>
    <el-button class="btn" type="primary" @click="handleClick">返回上一页</el-button>
</article>
</template>
<style scoped lang="stylus">
.article-detail
    h3
        margin 0
    .detail-card {
        margin-bottom: 10px;
        background: #f8f8f8;
        border-radius: 5px;
        padding: 10px;
    }
    .row {
        margin: 5px 0;
        span {
            color: #000;
            display:inline-block;
            width: 100px;
        }
    }
    .btn
        margin 30px

</style>
